import { Component } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UIBlockingService } from '../core/ui-blocking.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { merge, Observable } from 'rxjs';
import { NavigationExtras, Router } from '@angular/router';
import { DumbPendingLetter } from './DTOs/dumb-pending-letter';
import { PendingLettersService } from './pending-letters.service';
import { PendingLettersDtRetInfo } from './DTOs/pending-letters-dt-ret-info';
import { GetPendingLettersListRequest } from './DTOs/get-pending-letters-list-request';

@Component({
  selector: 'app-pending-letters',
    templateUrl: './pending-letters.component.html',
    providers: [UIBlockingService, NgbDropdown],
})
export class PendingLettersComponent {
    constructor(private pendingLettersService: PendingLettersService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private modalService: NgbModal
        , private router: Router) { }

    pendingLetters: DumbPendingLetter[] = [];
    totalLetters = 0;
    filteredLetters = 0;
    pageNum = 1;
    itemsPerPage = 10;
    //currentPageNum = 1;
    initialLoad = true;
    filtersChanged = false;
    searchText = "";
    statusSearch = { display: "Pending", value: 0 };
    sortType = 1;
    keywordSearches: string[] = [];

    get itemStart() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + 1;
    }
    get itemEnd() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + this.pendingLetters.length;
    }

    getPendingLettersObservable(): Observable<PendingLettersDtRetInfo> {
        var req = this.createSearchRequest();
        return this.pendingLettersService
            .getPendingLettersList(req);
    }

    ngOnInit() {
        var observablesMerged = merge(this.getPendingLettersObservable());
        this.blockUI.start();
        observablesMerged.subscribe(
            {
                next: (data) => {
                    this.pendingLetters = data.data;
                    this.totalLetters = data.recordsTotal;
                    this.filteredLetters = data.recordsFiltered;
                    this.initialLoad = false;
                },
                error: (err) => {
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                    console.log(err)
                },
                complete: () => {
                    this.blockUI.stop();
                    if (this.pendingLetters.length == 0) {
                        console.log(" no letters found ")
                    }
                }
            });
    }

    getPendingLetters() {
        this.blockUI.start();
        this.getPendingLettersObservable().subscribe(
            {
                next: (data) => {
                    this.pendingLetters = data.data;
                    this.totalLetters = data.recordsTotal;
                    this.filteredLetters = data.recordsFiltered;
                },
                error: (err) => {
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                    console.log(err)
                },
                complete: () => {
                    this.blockUI.stop();
                    if (this.pendingLetters.length == 0) {
                        console.log(" no letters found ")
                    }
                }
            });
    }

    createSearchRequest(): GetPendingLettersListRequest {
        var req = new GetPendingLettersListRequest();

        if (this.filtersChanged)
            this.pageNum = 1;

        req.PageNumber = this.pageNum - 1; //to get the 0-indexed number
        req.ItemsPerPage = this.itemsPerPage;

        req.KeywordSearches = this.keywordSearches;
        req.Sorting = this.sortType;

        req.StatusSearch = this.statusSearch.value;

        this.filtersChanged = false;

        return req;
    }

    enterSearchTerm(event: any) {
        if (event.keyCode != 13)//13 is enter
            return;

        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getPendingLetters();
        return;
    }

    removeSearchTerm(term: string) {
        var index = this.keywordSearches.indexOf(term);
        if (index != -1) {
            this.keywordSearches.splice(index, 1);
            this.filtersChanged = true;
        }
        this.getPendingLetters();
    }

    clearSearch() {
        this.searchText = "";
        this.sortType = 1;
        this.keywordSearches = [];
        this.filtersChanged = true;
        this.statusSearch = { display: "Pending", value: 0 };
        this.getPendingLetters();
    }
    hitSearchBtn() {
        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getPendingLetters();
    }

    changeSortType(column: number) {
        switch (column) {
            case 1:
                this.sortType = (this.sortType == 1) ? 2 : 1;
                break;
            case 2:
                this.sortType = (this.sortType == 3) ? 4 : 3;
                break;
            case 3:
                this.sortType = (this.sortType == 5) ? 6 : 5;
                break;
            case 4:
                this.sortType = (this.sortType == 7) ? 8 : 7;
                break;
            default:
                break;
        }
        this.getPendingLetters();
    }

    changeStatusSearch(toChange: number) {
        if (this.statusSearch.value == toChange)
            return;

        this.filtersChanged = true;
        switch (toChange) {
            case -1:
                this.statusSearch = { display: "All", value: -1 };
                break;
            case 0:
                this.statusSearch = { display: "Pending", value: 0 };
                break;
            case 1:
                this.statusSearch = { display: "Approved", value: 1 };
                break;
            case 2:
                this.statusSearch = { display: "Denied", value: 2 };
                break;
            default:
                this.statusSearch = { display: "Pending", value: 0 };
                break;
        }
        this.getPendingLetters();
    }
    get currentPageNum() { return this.pageNum };
    set currentPageNum(page: number) {
        this.pageNum = page;
        if (!this.initialLoad)
            this.getPendingLetters();
    }
}
